// @ts-ignore
import Slider from "react-slick";
import { Typography } from "theme";

import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const StyledImage = styled("img")(() => {
  return {
    height: "370px",
    width: "100%",
    objectFit: "cover",
  };
});

const StyledWrapper = styled(Box)(() => ({
  "& .slick-dots": {
    bottom: 0,
    height: "2px",

    "& li": {
      height: "2px",
    },
  },
}));

const StyledBullet = styled(Box)(() => ({
  width: "20px",
  height: "2px",
  backgroundColor: "#B5B5B5",
}));

const Carousel = () => {
  const settings = {
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    customPaging: () => <StyledBullet />,
  };
  return (
    <StyledWrapper mt={2.5} mb={5}>
      <Typography mb={1.5} variant="h2" color="primary" textTransform="uppercase" weight="regular">
        Фото
      </Typography>
      <Slider {...settings}>
        <Box>
          <StyledImage src="/x.jpeg" />
        </Box>
        <Box>
          <StyledImage src="/x.jpeg" />
        </Box>
      </Slider>
    </StyledWrapper>
  );
};

export default Carousel;
